import { v4 as uuidv4 } from 'uuid';

 var AssetannotationResourcePrefix = "https://api.platform.appmachine.in/assetannotation";
 var AssetannotationsResourcePrefix = "https://api.platform.appmachine.in/assetannotations";


export const createAPI = (payload, successCallBack, failuerCallback) => {
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
        body: JSON.stringify(payload)
    };

    fetch(AssetannotationResourcePrefix, requestOptions)
        .then(function(response) {
            if(response.ok)
            {
                return response.json();         
            }
            throw new Error('Something went wrong.');
        })
        .then((response) => {
            let errorMessage = "Something Went Wrong"
                if (response.status===208){
                    errorMessage = "Record already exist";
                    failuerCallback(errorMessage);
                } else if (500 === response.status) {
                    errorMessage='Internal Server Error';
                    failuerCallback(errorMessage);
                } else {
                    successCallBack(response);
                }
        })
        .catch(function(error) { 
            console.log('Request failed', error);
            failuerCallback('Internal Server Error');
        });
}


export function getAPI(id, loadForm){
    const token = localStorage.getItem("JWT");
    let response;
    const requestId = uuidv4().split("-")[4];
    try {
        const requestOptions = {
            method: 'GET',
            headers: {
                'X-Request-ID': requestId,
                'Authorization': `Bearer ${token}`}
            };
        fetch(AssetannotationResourcePrefix+'/'+id,requestOptions)
            .then((data) => data.json())
            .then((data) => {
                loadForm(data);
                //setData({data},{formValues}, setFormValues);
            })
    } catch (error) {
        // setAlert(true);
        console.log('There was an error', error);
    }
    
}

export function getListAPI(setAssetannotationList, dataFetchCallBack){
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];
    const requestOptions = {
      method: 'GET',
      headers: {
        'X-Request-ID': requestId,
        'Authorization': `Bearer ${token}`
    }
    };
    fetch(AssetannotationsResourcePrefix, requestOptions)
        .then((data) => data.json())
        .then((data) => {setAssetannotationList(data.list);dataFetchCallBack(data.list)})
}

export function deleteAPI(id, deleteCallBack){
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];
    const requestOptions = {
      method: 'DELETE',
      headers: {'X-Request-ID': requestId,'Authorization': `Bearer ${token}`}
    };
    fetch(AssetannotationResourcePrefix+"/"+id, requestOptions)
        .then((data) => data.json())
        .then((data) => {
            deleteCallBack(data);
        })
  }


export function updateAssetannotationInfo(assetannotationId, payload, successCallBack,failuerCallback){
    const requestId = uuidv4().split("-")[4];
    const token = localStorage.getItem("JWT");
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
      body: JSON.stringify(payload)
    };
    fetch(AssetannotationResourcePrefix+"/"+assetannotationId+"/assetannotationInfo", requestOptions)
            .then(function(response) {
            if(response.ok)
            {
                return response.json();         
            }
            throw new Error('Something went wrong.');
        })
        .then((response) => {
            let errorMessage = "Something Went Wrong"
                if (response.status===208){
                    errorMessage = "Record already exist";
                    failuerCallback(errorMessage);
                } else if (500 === response.status) {
                    errorMessage='Internal Server Error';
                    failuerCallback(errorMessage);
                } else {
                    successCallBack(response);
                }
        })
        .catch(function(error) { 
            console.log('Request failed', error);
            failuerCallback('Internal Server Error');
        });
}

export function getImageannotationInfoByBusinessidAPI(businessid, setAssetannotationList, dataFetchCallBack){
    const requestId = uuidv4().split("-")[4];
    const token = localStorage.getItem("JWT");
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
    };
    fetch(AssetannotationsResourcePrefix+"/businessid/"+businessid+"/businessid", requestOptions)
        .then((data) => data.json())
        .then((data) => {
          setAssetannotationList(data.list);
          dataFetchCallBack(data.list)
    })
}export function getAssetannotationInfoByAssetidAPI(assetid, setAssetannotationList, dataFetchCallBack){
    const requestId = uuidv4().split("-")[4];
    const token = localStorage.getItem("JWT");
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
    };
    fetch(AssetannotationsResourcePrefix+"/assetid/"+assetid+"/assetid", requestOptions)
        .then((data) => data.json())
        .then((data) => {
          setAssetannotationList(data.list);
          dataFetchCallBack(data.list)
    })
}